/**
 * @Author: zangkang
 * @Date:   2018-02-05T10:46:26+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-02-05T10:46:26+08:00
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {  Table, Divider, Spin, Input, Button, TreeSelect, Form, Modal, message, Radio } from 'antd';
import { fetchAddressList, exportAddressList } from '../../actions/employee-management-actions.js';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';
import './style.less';

const FormItem = Form.Item;

const { TreeNode } = TreeSelect;

const mapStateToProps = state => {
    return {
        routing: state.routing,
        employeeManagement: state.employeeManagement,
        departmentStructure: state.departmentStructure
    }
}

const Search = Input.Search;

const mapDispatchToProps = { fetchAddressList, exportAddressList, fetchDepartmentsList }

@connect(mapStateToProps, mapDispatchToProps)

class AddressList extends Component{
	constructor(props){
  	super(props);
    this.columns = [{
      title: 'Employee number',
      dataIndex: 'job_number',
      key: 'job_number',
    }, {
      title: 'Department',
      dataIndex: 'department_name',
      key: 'department_name',
    }, {
      title: 'Workplace',
      dataIndex: 'position_name',
      key: 'position_name',
    }, {
      title: 'Surname',
      dataIndex: 'real_name',
      key: 'real_name',
    },  {
      title: 'Phone number',
      dataIndex: 'cell_phone',
      key: 'cell_phone',
    }, {
      title: 'Employment date',
      dataIndex: 'entry_date',
      key: 'entry_date',
    }];
  }
	state = {
    department_ids:null,
    name:null
  }
  componentWillReceiveProps(nextProps) {
    console.log(nextProps);
  }
	componentDidMount() {
    this.setState({job_status: true});
    this._fetchAddressList({job_status: true})
		this._fetchDepartmentsList()
    }
 	_fetchAddressList = (params) => {
     	this.props.fetchAddressList(params)
 	}
 	_fetchDepartmentsList = (params) => {
		this.props.fetchDepartmentsList(params);
 	}
  handleAddressListSearch = (value) => {
    let params = {
       real_name: value,
       job_number: value
    }
    let gets = {};
    for (let key in this.state) {
      if (this.state[key] !== undefined) {
        gets[key] = this.state[key];
      }
    }
    gets = { ...gets, ...params }
    this.setState(params);
    this.props.fetchAddressList(gets)
  }
  handleDepartmentSelectChange = (value) => {
    let params = {
       department_ids: value
    }
    let gets = {};
    for (let key in this.state) {
      if (this.state[key] !== undefined) {
        gets[key] = this.state[key];
      }
    }
    gets = { ...gets, ...params }
    this.setState(params);
    this.props.fetchAddressList(gets)
  }
  onSelectTreeChange(ids) {
    let params = {
      department_ids: ids
    }
    let gets = {};
    for (let key in this.state) {
      if (this.state[key] !== undefined) {
        gets[key] = this.state[key];
      }
    }
    gets = { ...gets, ...params }
    this.setState(params);
    this.props.fetchAddressList(gets)
  }
  selectStatus(event) {
    let params = {
      job_status: event.target.value
    }
    let gets = {};
    for (let key in this.state) {
      if (this.state[key] !== undefined) {
        gets[key] = this.state[key];
      }
    }
    gets = { ...gets, ...params }
    this.setState(params);
    this.props.fetchAddressList(gets)
  }
  handleExportAddressList = () => {
  	let params = {
  		department_ids: this.state.department_ids,
  		real_name: this.state.name,
  		job_number: this.state.name
  	}
    let ref = Modal.info({content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"});
  	this.props.exportAddressList(params, url => {
      ref.destroy();
      if (url) {  
        window.open(url);
      }else{
        message.error('下载失败', 4);
      }
    });
  }
 	fetchAddressListPage(pagination) {
 		let params = {
      page: pagination.current
    }
    let gets = params;
    for (let key in this.state) {
      if (this.state[key] !== undefined) {
        gets[key] = this.state[key];
      }
    }
		this.props.fetchAddressList(gets)
	}
  renderTreeNodes = (data) => {
    return data.map((item) => {
      if (item.children) {
        return (
          <TreeNode title={item.name} value={`${item.id}`} key={item.id} dataRef={item}>
            { item.children.length !== 0 && this.renderTreeNodes(item.children) }
          </TreeNode>
        );
      }
      return <TreeNode {...item} />;
    });
  }
  render(){
  	const { addressList } = this.props.employeeManagement;
  	const { departmentsList } = this.props.departmentStructure;
  	const columns = this.columns;
  	// const paginationCfg = {
   //  pageSize: 10
   //  };
    const { getFieldDecorator } = this.props.form;
  	return (
      <div className="app-module-item">
        <div className="colAction">
          <div style={{float:"left",margin:"4px 0px 15px"}}>
            {this.props.access.addressList.export_value && 
              <Button type="primary" onClick={this.handleExportAddressList}>导出</Button>
            }
            <Divider type="vertical" />
            <Search
              placeholder="请输入员工姓名或工号"
              onSearch={this.handleAddressListSearch}
              style={{ width: 240 }}
              enterButton
            />
            <Divider type="vertical" />
          </div>
         {
             departmentsList ?
             <Form layout="inline" style={{float:'left'}}>
              <FormItem>
                {getFieldDecorator('department_id')(
                  <TreeSelect style={{minWidth:"300px",marginBottom:'15px'}}
                     multiple
                     placeholder="请选择部门"
                     showSearch={false}
                     autoExpandParent={true}
                     dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                     treeDefaultExpandAll
                     onChange={this.onSelectTreeChange.bind(this)}>
                      {this.renderTreeNodes(departmentsList)}
                  </TreeSelect>
                )}
              </FormItem>
              </Form>
             :
             <Spin />
         }
        <div style={{float:"right",margin:"4px 0px 15px"}}>
          <Radio.Group defaultValue="1" onChange={this.selectStatus.bind(this)}>
            <Radio.Button value="1">在职</Radio.Button>
            <Radio.Button value="0">离职</Radio.Button>
          </Radio.Group>
        </div>
      </div>
      <div style={{clear:"both"}}></div>
      {
        addressList ?
        <Table
           columns={columns}
           dataSource={addressList.Data}
           rowKey={record => record.id}
           pagination={{
            total: addressList.Total,
            pageSize:addressList.PageSize,
            current: addressList.Page,  
            defaultCurrent: 1}}
           onChange={this.fetchAddressListPage.bind(this)}
        />:<Spin />
      }
      </div>
    )
  }
}

AddressList = Form.create()(AddressList)

AddressList = LayoutWrapper(AddressList)

export default AddressList;



// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/AddressListEn.js